import React, { useEffect, useState, useContext } from 'react'
import Item from './item'
import styles from './index.module.less'
import { guessYouLike } from '@/apis/share'
import Conetext from '../../context'

interface YouLikeProps {
  topId: number
  categoryId: number
  timeRange: string
  onObserver: (data) => void
}

const isScrollToBottom = () => {
  const scrollD = 200
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
  const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
  return scrollTop + windowHeight + scrollD >= scrollHeight
}
const useBottom = (action) => {
  function doInBottom() {
    return isScrollToBottom() && action()
  }
  useEffect(() => {
    window.addEventListener('scroll', doInBottom)
    // 组件卸载或函数下一次执行时，会先执行上一次函数内部return的方法
    return () => {
      window.removeEventListener('scroll', doInBottom)
    }
  }, [])
}

function YouLike(props: YouLikeProps) {
  const { langConfig, lang, editConfig } = useContext(Conetext)

  const { topId, categoryId, timeRange, onObserver } = props
  const pageSize = 6
  let cacheList = []
  const [list, setData] = useState([])
  // pageSize 是不是从1 开始
  const [page, setPage] = useState(1)
  const [isNoMore, setIsNoMore] = useState(false)

  // 获取列表数据
  useEffect(() => {
    guessYouLike(
      {
        pageSize,
        page,
        topId,
        categoryId,
        language: lang,
        countryCode: editConfig.local,
        timeRange,
      },
      {
        language: lang,
        countryCode: editConfig.local,
      }
    ).then(({ code, data }) => {
      if (code !== 200) {
        return
      }
      !data.dataList.length && setIsNoMore(true)

      setData((list) => {
        const newList = [...list, ...cacheList, ...data.dataList]
        cacheList = []
        // 处理奇数
        if (newList.length % 2 !== 0) {
          cacheList.push(newList.pop())
          return newList
        }
        return newList
      })
      if (page > 1) onObserver(list)
    })
  }, [page])

  useEffect(() => {
    cacheList = []
    setData([])
    setPage(1)
  }, [categoryId, timeRange])

  useBottom(() => {
    if (isNoMore) return
    setPage(page + 1)
  })

  if (!list.length) return <div></div>
  return (
    <div className={styles['main']}>
      <div className={styles['head']}>{(langConfig as any).youLike.headTitle}</div>
      <div className={styles['list']}>
        {list.map((item, index) => {
          return <Item key={item.spuId} item={item} index={index} />
        })}
      </div>
    </div>
  )
}

export default YouLike
